import type { StudentInfo } from '../hooks/useStudentsMap';

export const MOCK_STUDENT_IDS = [
  'mock-user-01',
  'mock-user-02',
  'mock-user-03',
  'mock-user-04',
  'mock-user-05',
  'mock-user-06',
  'mock-user-07',
  'mock-user-08',
  'mock-user-09',
  'mock-user-10',
  'mock-user-11',
  'mock-user-12',
  'mock-user-13',
  'mock-user-14',
  'mock-user-15',
  'mock-user-16',
  'mock-user-17',
  'mock-user-18',
  'mock-user-19',
  'mock-user-20',
  'mock-user-21',
  'mock-user-22',
  'mock-user-23',
  'mock-user-24',
  'mock-user-25',
  'mock-user-26',
];

const mockStudentInfos: [string, StudentInfo][] = [
  [MOCK_STUDENT_IDS[0], { name: 'Maria', lastName: 'Garcia', avatar: '/images/avatars/1.png', groupName: '5º A' }],
  [MOCK_STUDENT_IDS[1], { name: 'Pedro', lastName: 'Lopez', avatar: '/images/avatars/2.png', groupName: '5º A' }],
  [MOCK_STUDENT_IDS[2], { name: 'Ana', lastName: 'Martinez', avatar: '/images/avatars/3.png', groupName: '5º A' }],
  [MOCK_STUDENT_IDS[3], { name: 'Juan', lastName: 'Rodriguez', avatar: '/images/avatars/4.png', groupName: '5º B' }],
  [MOCK_STUDENT_IDS[4], { name: 'Sofia', lastName: 'Hernandez', avatar: '/images/avatars/5.png', groupName: '5º B' }],
  [MOCK_STUDENT_IDS[5], { name: 'Carlos', lastName: 'Diaz', avatar: '/images/avatars/6.png', groupName: '5º A' }],
  [MOCK_STUDENT_IDS[6], { name: 'Laura', lastName: 'Torres', avatar: '/images/avatars/7.png', groupName: '5º B' }],
  [MOCK_STUDENT_IDS[7], { name: 'Diego', lastName: 'Ruiz', avatar: '/images/avatars/8.png', groupName: '5º A' }],
  [MOCK_STUDENT_IDS[8], { name: 'Isabella', lastName: 'Moreno', avatar: '/images/avatars/9.png', groupName: '5º A' }],
  [MOCK_STUDENT_IDS[9], { name: 'Martín', lastName: 'Herrera', avatar: '/images/avatars/10.png', groupName: '5º B' }],
  [MOCK_STUDENT_IDS[10], { name: 'Lucía', lastName: 'Aguirre', avatar: null, groupName: '5º A' }],
  [MOCK_STUDENT_IDS[11], { name: 'Santiago', lastName: 'Reyes', avatar: null, groupName: '5º B' }],
  [MOCK_STUDENT_IDS[12], { name: 'Elena', lastName: 'Sanchez', avatar: '/images/avatars/13.png', groupName: '5º A' }],
  [MOCK_STUDENT_IDS[13], { name: 'Miguel', lastName: 'Fernandez', avatar: '/images/avatars/14.png', groupName: '5º B' }],
  [MOCK_STUDENT_IDS[14], { name: 'Carmen', lastName: 'Gonzalez', avatar: '/images/avatars/15.png', groupName: '5º A' }],
  [MOCK_STUDENT_IDS[15], { name: 'Alejandro', lastName: 'Perez', avatar: '/images/avatars/16.png', groupName: '5º B' }],
  [MOCK_STUDENT_IDS[16], { name: 'Lucia', lastName: 'Romero', avatar: '/images/avatars/17.png', groupName: '5º A' }],
  [MOCK_STUDENT_IDS[17], { name: 'Pablo', lastName: 'Navarro', avatar: '/images/avatars/18.png', groupName: '5º B' }],
  [MOCK_STUDENT_IDS[18], { name: 'Valentina', lastName: 'Castillo', avatar: '/images/avatars/19.png', groupName: '5º A' }],
  [MOCK_STUDENT_IDS[19], { name: 'Mateo', lastName: 'Gil', avatar: '/images/avatars/20.png', groupName: '5º B' }],
  [MOCK_STUDENT_IDS[20], { name: 'Daniela', lastName: 'Ortiz', avatar: '/images/avatars/21.png', groupName: '5º A' }],
  [MOCK_STUDENT_IDS[21], { name: 'Adrian', lastName: 'Mendez', avatar: '/images/avatars/22.png', groupName: '5º B' }],
  [MOCK_STUDENT_IDS[22], { name: 'Camila', lastName: 'Vargas', avatar: '/images/avatars/23.png', groupName: '5º A' }],
  [MOCK_STUDENT_IDS[23], { name: 'Nicolas', lastName: 'Ramos', avatar: '/images/avatars/24.png', groupName: '5º B' }],
  [MOCK_STUDENT_IDS[24], { name: 'Paula', lastName: 'Flores', avatar: '/images/avatars/25.png', groupName: '5º A' }],
  [MOCK_STUDENT_IDS[25], { name: 'Roberto', lastName: 'Silva', avatar: '/images/avatars/26.png', groupName: '5º B' }],
];

export const MOCK_STUDENTS_MAP: Map<string, StudentInfo> = new Map(mockStudentInfos);
